<template>
  <IQOS :readonly="editing" :title="$t('preorder.time_limit.title')">
      <div class="c-grey current-text" v-if="!editing">
          {{ $t('preorder.time_limit.current', {
              time: formatTimeValue(close_time_limit)
          }) }}
      </div>
      <!-- <div class="c-grey current-text" v-if="!editing && !close_time_limit">
          {{ $t('preorder.time_limit.zero') }}
      </div> -->
      <!-- <BaseInput class="w-100" readonly :value="`${formatTimeValue(close_time_limit)}`" v-if="!editing"/> -->
      <BaseInput class="w-100" :readonly="false" type="number" v-model.number="close_time_limit" v-if="editing"/>
      <p class="c-grey comment iqos-bottom-comment" v-if="editing">
          {{$t('preorder.time_limit.input')}}
      </p>
      <IQOSActions 
        :editing="editing"
        @edit="showEditUI"
        @cancel="hideEditUI"
        @accept="onEditFinish"/>
  </IQOS>
</template>

<script>
import IQOS from '@/components/IQOS.vue'
import IQOSActions from '@/components/IQOSActions.vue'

import BlackInput from '@/components/BlackInput.vue'

export default {
    data() {
        return {
            editing: false,

            close_time_limit: 0
        }
    },
    props: {
        mode: {
            type: String,
            default: 'delivery'
        }
    },
    components: {
        IQOS,
        IQOSActions,
        BlackInput
    },
    methods: {
        showEditUI() {
            this.editing = true;
        },
        hideEditUI() {
            this.editing = false;
            this.setInitialValue();
        },
        onEditFinish() {
            this.$store.commit('setCafeCloseTimeLimit', {
                mode: this.mode,
                close_time_limit: this.close_time_limit
            });
            this.$store.dispatch('saveCafe');

            this.editing = false;
        },
        setInitialValue() {
            if (this.cafe[this.mode].close_time_limit) {
                this.close_time_limit = this.cafe[this.mode].close_time_limit;
            } else {
                this.close_time_limit = 0;
            }
        },
        formatTimeValue(v) {
            if (v < 60) {
                return `${v} ${this.$t('units.mins')}`;
            }

            const hours = Math.floor(v / 60);
            const minutes = v % 60;

            if (minutes == 0) return `${hours} ${this.$t('units.hours')}`;

            return `${hours} ${this.$t('units.hours')} ${minutes} ${this.$t('units.mins')}`;
        }
    },
    mounted() {
        this.setInitialValue();
    },
    computed: {
        cafe() {
            return this.$store.state.cafe;
        }
    }
}
</script>

<style scoped>
.current-text {
    text-align: center;
    font-size: 2vh;
}
</style>